import React from 'react';
import { Card } from '../components/ui/card';
import { Scale } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-950 py-16">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-gradient-to-br from-emerald-500/20 to-cyan-500/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Scale className="w-10 h-10 text-emerald-400" />
            </div>
            <h1 className="text-5xl font-bold text-white mb-4">Terms of Service</h1>
            <p className="text-slate-400">Last Updated: {new Date().toLocaleDateString()}</p>
          </div>

          <Card className="bg-gradient-to-br from-slate-900/90 to-slate-900/50 backdrop-blur-sm border-slate-800/50 p-10">
            <div className="space-y-8 text-slate-300">
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
                <p className="leading-relaxed">
                  By accessing and using CollegeTrue ("the Service"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">2. Description of Service</h2>
                <p className="leading-relaxed mb-4">
                  CollegeTrue provides educational cost estimation tools, scholarship matching services, and college comparison features. The Service is intended to assist students and families in understanding college affordability.
                </p>
                <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4">
                  <p className="text-amber-400 font-semibold">Important Disclaimer:</p>
                  <p className="mt-2">The Service provides estimates and suggestions only. It is NOT financial advice, legal advice, or a guarantee of admission or financial aid.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">3. User Responsibilities</h2>
                <p className="leading-relaxed mb-3">You agree to:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide accurate information when using our calculators</li>
                  <li>Verify all information with official college financial aid offices</li>
                  <li>Not rely solely on our estimates for financial decisions</li>
                  <li>Use the Service for lawful purposes only</li>
                  <li>Not attempt to scrape, hack, or abuse the Service</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">4. Data Accuracy & Limitations</h2>
                <p className="leading-relaxed mb-3">
                  While we strive for accuracy, we cannot guarantee that:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>All college cost data is current or complete</li>
                  <li>Scholarship information is up-to-date</li>
                  <li>Calculations reflect your actual financial aid eligibility</li>
                  <li>Alternative college suggestions are suitable for your specific needs</li>
                </ul>
                <p className="mt-4 leading-relaxed">
                  <strong className="text-white">You must verify all information with official sources before making any financial or educational decisions.</strong>
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">5. No Financial Advice</h2>
                <p className="leading-relaxed">
                  CollegeTrue does not provide financial, legal, or educational advice. Our tools are for informational and educational purposes only. You should consult with qualified professionals (financial advisors, college counselors, legal advisors) before making significant financial or educational decisions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">6. Limitation of Liability</h2>
                <p className="leading-relaxed mb-3">
                  To the fullest extent permitted by law, CollegeTrue and its operators shall not be liable for:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Any financial losses or educational decisions made based on our estimates</li>
                  <li>Inaccurate, outdated, or incomplete data</li>
                  <li>Technical errors or service interruptions</li>
                  <li>Third-party scholarship or college websites</li>
                  <li>Any direct, indirect, incidental, or consequential damages</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">7. Third-Party Links</h2>
                <p className="leading-relaxed">
                  The Service contains links to third-party websites (colleges, scholarship programs, etc.). We do not endorse, control, or assume responsibility for the content, privacy policies, or practices of any third-party sites. You access third-party sites at your own risk.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">8. Changes to Service</h2>
                <p className="leading-relaxed">
                  We reserve the right to modify, suspend, or discontinue any part of the Service at any time without notice. We may also update these Terms of Service periodically. Continued use of the Service after changes constitutes acceptance of the updated terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">9. Intellectual Property</h2>
                <p className="leading-relaxed">
                  All content, features, and functionality of the Service are owned by CollegeTrue and are protected by intellectual property laws. You may not copy, modify, distribute, or create derivative works without express written permission.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">10. Governing Law</h2>
                <p className="leading-relaxed">
                  These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">11. Contact Information</h2>
                <p className="leading-relaxed">
                  If you have questions about these Terms, please contact us through our Contact page.
                </p>
              </section>

              <div className="bg-slate-800/30 rounded-lg p-6 mt-8">
                <p className="text-sm text-slate-400">
                  By using CollegeTrue, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Terms;